/* ============================================================
   DAULATRAM'S — Universal Dual-Engine Category & Filter Engine
   ============================================================ */
(function () {
  'use strict';

  function initShopFilters() {
    const grid = document.getElementById('drazzel-shop-grid');
    const countLabel = document.getElementById('shop-count-label');
    const sidebar = document.querySelector('.shop-sidebar-filters');
    const pillsScroll = document.querySelector('.shop-cat-pills-scroll');

    if (!grid) return;

    let cards = Array.from(grid.querySelectorAll('.product-card'));
    let activePillCat = 'all';

    function updateCount(count) {
      if (countLabel) {
        countLabel.textContent = `${count} products`;
      }
    }

    if (cards.length > 0) {
      updateCount(cards.length);
    }

    function checkMatch(card, priceFilters, catFilters, sizeFilters) {
      let matchPrice = priceFilters.length === 0;
      let matchCat = catFilters.length === 0;
      let matchSize = sizeFilters.length === 0;

      // 1. Price Matching
      const priceRupees = parseFloat(card.dataset.priceRupees) || 0;
      if (priceFilters.length > 0) {
        matchPrice = priceFilters.some(val => {
          if (val === 'under-500') return priceRupees < 500;
          if (val === '500-999') return priceRupees >= 500 && priceRupees <= 999;
          if (val === '1000-1499') return priceRupees >= 1000 && priceRupees <= 1499;
          if (val === '1500-plus') return priceRupees >= 1500;
          return false;
        });
      }

      // 2. Category Matching
      const title = (card.dataset.productTitle || '').toLowerCase();
      const cat = (card.dataset.category || '').toLowerCase();
      const tags = (card.dataset.tags || '').toLowerCase();
      const text = (card.textContent || '').toLowerCase();
      const handle = (card.dataset.handle || '').toLowerCase();
      const fullText = title + ' ' + cat + ' ' + tags + ' ' + handle + ' ' + text;

      if (catFilters.length > 0) {
        matchCat = catFilters.some(val => {
          if (val === 'all') return true;

          if (val === 'mens-wellness') {
            return fullText.includes('men') || fullText.includes('shilajit') || fullText.includes('shakti') || fullText.includes('veer') || fullText.includes('dhatu');
          }
          if (val === 'womens-wellness') {
            return fullText.includes('women') || fullText.includes('nari') || fullText.includes('kalp') || fullText.includes('period') || fullText.includes('pcos');
          }
          if (val === 'hair-care') {
            return fullText.includes('hair') || fullText.includes('shampoo') || fullText.includes('bhringraj') || fullText.includes('onion') || fullText.includes('spa');
          }
          if (val === 'skin-care') {
            return (fullText.includes('skin') || fullText.includes('serum') || fullText.includes('gel') || fullText.includes('aloevera') || fullText.includes('rose') || fullText.includes('face') || fullText.includes('charcoal') || fullText.includes('papaya') || fullText.includes('apricot') || fullText.includes('multani')) && !fullText.includes('shampoo');
          }
          if (val === 'desi-ghee') {
            return fullText.includes('ghee') || fullText.includes('a2') || fullText.includes('cow');
          }
          if (val === 'honey') {
            return fullText.includes('honey') || fullText.includes('murabba') || fullText.includes('tulsi honey') || fullText.includes('multiflora');
          }
          if (val === 'cold-pressed-oils') {
            return fullText.includes('cold pressed') || fullText.includes('badam rogan') || fullText.includes('sesame') || fullText.includes('flax') || fullText.includes('walnut') || fullText.includes('kalonji') || (fullText.includes('coconut') && fullText.includes('oil')) || (fullText.includes('castor') && fullText.includes('oil'));
          }
          if (val === 'wellness') {
            return fullText.includes('wellness') || fullText.includes('spirulina') || fullText.includes('capsule') || fullText.includes('powder') || fullText.includes('churan') || fullText.includes('latte') || fullText.includes('dib');
          }
          if (val === 'weight-loss') {
            return fullText.includes('slim') || fullText.includes('tea') || fullText.includes('loss') || fullText.includes('weight');
          }
          if (val === 'kitchen-home') {
            return fullText.includes('gud') || fullText.includes('mishri') || fullText.includes('pickle') || fullText.includes('chutney') || fullText.includes('hawan') || fullText.includes('shakkar') || fullText.includes('khand') || fullText.includes('haldi') || fullText.includes('dhoop');
          }

          const cleanVal = val.replace(/-/g, ' ');
          return fullText.includes(cleanVal) || fullText.includes(val);
        });
      }

      // 3. Size Matching
      const opts = (card.dataset.options || '').toLowerCase();
      const fullSizeText = opts + ' ' + text;
      if (sizeFilters.length > 0) {
        matchSize = sizeFilters.some(val => {
          const cleanVal = val.replace(/-/g, ' ');
          return fullSizeText.includes(cleanVal) || fullSizeText.includes(val);
        });
      }

      return matchPrice && matchCat && matchSize;
    }

    function applyAllFilters() {
      cards = Array.from(grid.querySelectorAll('.product-card'));
      const checkedBoxes = sidebar ? Array.from(sidebar.querySelectorAll('input[type="checkbox"]:checked')) : [];

      const priceFilters = checkedBoxes.filter(cb => cb.dataset.filterType === 'price').map(cb => cb.value);
      const catFilters = checkedBoxes.filter(cb => cb.dataset.filterType === 'category').map(cb => cb.value);
      const sizeFilters = checkedBoxes.filter(cb => cb.dataset.filterType === 'size').map(cb => cb.value);

      if (activePillCat !== 'all') {
        catFilters.length = 0; // Active pill strictly overrides category checkboxes
        catFilters.push(activePillCat);
      }

      let visibleCount = 0;

      cards.forEach(card => {
        const isMatched = checkMatch(card, priceFilters, catFilters, sizeFilters);
        if (isMatched) {
          card.style.setProperty('display', 'flex', 'important');
          visibleCount++;
        } else {
          card.style.setProperty('display', 'none', 'important');
        }
      });

      updateCount(visibleCount);
    }

    // Category Pills are native <a> links pointing to /collections/<handle>

    // Attach Sidebar Checkbox Handlers
    if (sidebar) {
      sidebar.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        cb.addEventListener('change', function () {
          if (this.dataset.filterType === 'category') {
            const targetCat = this.checked ? this.value : 'all';
            const targetUrl = targetCat === 'all' ? '/collections/all' : `/collections/${targetCat}`;
            if (window.location.pathname !== targetUrl) {
              window.location.href = targetUrl;
              return;
            }
          }
          applyAllFilters();
        });
      });
    }
  }

  // Guaranteed execution hooks
  initShopFilters();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopFilters);
  }
  window.addEventListener('load', initShopFilters);
  setTimeout(initShopFilters, 250);
  setTimeout(initShopFilters, 800);
})();
